"use client";

import { Box, Typography, Button, LinearProgress } from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

const UploadArea = styled("div")(({ theme, isDragOver }) => ({
  border: `2px dashed ${
    isDragOver ? theme.palette.primary.main : theme.palette.divider
  }`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(4),
  textAlign: "center",
  cursor: "pointer",
  transition: "all 0.3s ease",
  backgroundColor: isDragOver ? theme.palette.action.hover : "transparent",
  "&:hover": {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.action.hover,
  },
}));

export default function FileUploadArea({
  title,
  description,
  acceptedTypes,
  onFileSelect,
  isUploading,
  uploadProgress,
  multiple = true,
}) {
  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    onFileSelect?.(files);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = Array.from(event.dataTransfer.files);
    onFileSelect?.(files);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <Box>
      <UploadArea
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        isDragOver={false}
      >
        <CloudUpload sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {description}
        </Typography>
        <input
          type="file"
          multiple={multiple}
          accept={acceptedTypes}
          onChange={handleFileChange}
          style={{ display: "none" }}
          id="file-upload-input"
          disabled={isUploading}
        />
        <Button
          variant="outlined"
          component="label"
          htmlFor="file-upload-input"
          startIcon={<CloudUpload />}
          disabled={isUploading}
        >
          {isUploading ? "Subiendo..." : "Seleccionar Archivos"}
        </Button>
      </UploadArea>

      {isUploading && (
        <Box sx={{ mt: 3 }}>
          <LinearProgress variant="determinate" value={uploadProgress} />
          <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>
            Subiendo archivo... {uploadProgress}%
          </Typography>
        </Box>
      )}
    </Box>
  );
}
